"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const profiles = {
  default: {
    border: "2px solid ".concat(_BaseTheme.default.colors.bluegray),
    boxShadow: 'none',
    mainPadding: '1.5rem',
    borderStyle: 'solid',
    borderRadius: 0
  },
  sidebar: {
    border: '1px solid rgb(235, 235, 235)',
    boxShadow: 'rgba(0, 0, 0, 0.1) 0px 0px 5px',
    mainPadding: '2rem 1.5rem',
    borderStyle: 'none solid solid',
    borderRadius: 0
  },
  table: {
    border: "2px solid ".concat(_BaseTheme.default.colors.bluegray),
    boxShadow: 'none',
    mainPadding: 0,
    borderStyle: 'solid',
    borderRadius: 0
  },
  surface: {
    border: '1px solid rgba(180, 180, 180, 0.3);',
    boxShadow: '0px 1px 12px rgba(163, 177, 198, 0.5);',
    borderRadius: '3px',
    mainPadding: '1.87rem',
    borderStyle: 'solid'
  }
};

const BoxContainer = _styledComponents.default.div.withConfig({
  displayName: "BoxContainer",
  componentId: "design-system__vi5wsx-0"
})(["border:", ";box-shadow:", ";border-style:", ";border-radius:", ";background-color:", ";p{margin:0 0 ", ";}& > header{border-bottom:1px solid ", ";padding:", ";display:flex;justify-content:space-between;}& > main{padding:", ";}"], _ref => {
  let {
    profile
  } = _ref;
  return profiles[profile].border;
}, _ref2 => {
  let {
    profile
  } = _ref2;
  return profiles[profile].boxShadow;
}, _ref3 => {
  let {
    profile
  } = _ref3;
  return profiles[profile].borderStyle;
}, _ref4 => {
  let {
    profile
  } = _ref4;
  return profiles[profile].borderRadius;
}, _BaseTheme.default.colors.white, _BaseTheme.default.distance.normal, _BaseTheme.default.colors.bluegray, _BaseTheme.default.distance.small, _ref5 => {
  let {
    profile
  } = _ref5;
  return profiles[profile].mainPadding;
});

BoxContainer.propTypes = {
  profile: _propTypes.default.oneOf(['default', 'sidebar', 'table', 'surface'])
};
BoxContainer.defaultProps = {
  profile: 'default'
};
var _default = BoxContainer;
exports.default = _default;